import "./ResearchArticle.scss";
import { useTheme } from "../../../context/ThemeContext";
import { useEffect } from "react";

import { Link } from "react-router-dom";

function ResearchArticle({ title, date, type, image, square, preview, link }) {
  const { setThemeByName } = useTheme();

  useEffect(() => {
    setThemeByName("theme2");

    return () => {
      setThemeByName("default");
    };
  }, [setThemeByName]);

  return (
    <div className="research-article">
      <div className="research-article__info">
        <div className="research-article__info-type">
          <img
            src={square}
            alt=""
            className="research-article__info-type-square"
          />
          <div className="research-article__info-type-text">{type}</div>
        </div>
        <div className="research-article__info-date">{date}</div>
      </div>
      <div className="research-article__content">
        <div className="research-article__content-text">
          <Link
            to={link}
            className="research-article__content-text-title"
          >
            <div className="research-article__content-text-title">{title}</div>
          </Link>
          <div className="research-article__content-text-preview">
            {preview}
          </div>
        </div>
        <img src={image} alt="" className="research-article__content-image" />
      </div>
    </div>
  );
}

export default ResearchArticle;
